import instance from 'utils/axios/instance.axios';
import { PROPOSAL_PROGRAMS } from './_constant';

export const getAllByFilter = (pagination, filters) =>
  instance.get(PROPOSAL_PROGRAMS.GET_ALL, {
    params: {
      ...pagination,
      ...filters,
    },
  });

export const getAll = (pagination, filters) =>
  instance.get(PROPOSAL_PROGRAMS.GET_ALL, {
    params: {
      ...pagination,
      ...filters,
    },
  });

export const getAllWithNoFilter = () => instance.get(PROPOSAL_PROGRAMS.GET_ALL_WITH_NO_FILTER);

export const create = (data = {}) => instance.post(PROPOSAL_PROGRAMS.CREATE, data);

export const update = ({ id, data }) => instance.patch(PROPOSAL_PROGRAMS.UPDATE(id), data);

export const deleteById = (id) => instance.delete(PROPOSAL_PROGRAMS.DELETE(id));
